var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaceBad = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16.29,
  cy: 16,
  r: 16,
  fill: "#FD5C5C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFFCFC",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M10.89 19.48h10.259"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m22.904 12.775-3.586 2.044M12.892 14.54 9.25 12.754",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgFaceBad;